import React, { useEffect, useState } from 'react';
import { Button, Avatar, Input, Rate } from 'antd';
import { FaArrowLeft } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import style from '../../Styles/AddUser.module.css';
import { TrainingsApi } from '../../Api/TrainingsApi';
import { toastSuccess, toastError } from '../Toast/ToastComponent';
import { useAuth } from '../../Context/AuthContext';

const { TextArea } = Input;
const TrainingsReview = () => {
  const { authState } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const trainingId = location?.state?.trainingId;
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [trainees, setTrainees] = useState([]);
  const [feedbacks, setFeedbacks] = useState({});
  useEffect(() => {
    if (trainingId) {
      getTrainees();
    }
  }, [trainingId]);
  const getTrainees = async () => {
    try {
      setLoading(true);

      const payload = {
        training_id: trainingId,
      };

      const response = await TrainingsApi.getTrainerFeedback(payload);

      if (response.data.success) {
        const traineesList = response.data.result || [];
        setTrainees(traineesList);
        const initialFeedbacks = {};
        traineesList.forEach((item) => {
          if (item.rating || item.comments) {
            initialFeedbacks[item.trainee_id] = {
              rating: item.rating || 0,
              comments: item.comments || '',
            };
          }
        });
        setFeedbacks(initialFeedbacks);
      } else {
        toastError(response.data.message);
      }
    } catch (error) {
      console.log(error);

      toastError('Failed to fetch trainees');
    } finally {
      setLoading(false);
    }
  };
  const handleRating = (traineeId, value) => {
    setFeedbacks((prev) => ({
      ...prev,

      [traineeId]: {
        ...prev[traineeId],

        rating: value,
      },
    }));
  };
  const handleComment = (traineeId, value) => {
    setFeedbacks((prev) => ({
      ...prev,

      [traineeId]: {
        ...prev[traineeId],

        comments: value,
      },
    }));
  };
  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);

      const formattedFeedbacks = trainees.map((item) => ({
        trainee_id: item.trainee_id,

        rating: feedbacks[item.trainee_id]?.rating || 0,

        comments: feedbacks[item.trainee_id]?.comments || '',
      }));

      const payload = {
        training_id: trainingId,

        trainer_id: authState?.id,

        feedbacks: formattedFeedbacks,
      };

      const response = await TrainingsApi.createTrainerFeedback(payload);

      if (response.data.success) {
        toastSuccess('Review submitted successfully');

        navigate(-1);
      } else {
        toastError(response.data.message);
      }
    } catch (error) {
      console.log(error);

      toastError('Failed to submit review');
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
      }}
    >
      <div className="d-flex align-items-center mb-4">
        <div
          className={`${style['arrow-icon']} border px-2 pb-1`}
          onClick={() => navigate(-1)}
          style={{
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </div>
        <h5
          style={{
            marginLeft: 13,
          }}
          className="mb-0"
        >
          Write a Review
        </h5>
      </div>
      {trainees.map((item) => {
        const avatarText = item?.trainee_name
          ?.split(' ')
          ?.map((word) => word[0])
          ?.join('')
          ?.slice(0, 2)
          ?.toUpperCase();

        return (
          <div
            key={item.trainee_id}
            style={{
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              padding: 20,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: 14,
                }}
              >
                <Avatar
                  size={48}
                  style={{
                    background: '#1677ff',
                    fontWeight: 600,
                  }}
                >
                  {avatarText}
                </Avatar>

                <div>
                  <h5
                    style={{
                      margin: 0,
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    {item.trainee_name}
                  </h5>

                  <span
                    style={{
                      color: '#6b7280',
                    }}
                  >
                    {item.department_name}
                  </span>
                </div>
              </div>
              <Rate
                value={feedbacks[item.trainee_id]?.rating || 0}
                onChange={(value) => handleRating(item.trainee_id, value)}
              />
            </div>
            <div>
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: 10,
                }}
              >
                Comments
              </div>
              <TextArea
                rows={4}
                placeholder="Write comments..."
                value={feedbacks[item.trainee_id]?.comments || ''}
                onChange={(e) => handleComment(item.trainee_id, e.target.value)}
              />
            </div>
          </div>
        );
      })}
      <div className="text-end">
        <Button
          size="medium"
          style={{
            width: 100,
          }}
          onClick={() => navigate(-1)}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          style={{
            marginLeft: 12,
          }}
          loading={submitLoading}
          onClick={handleSubmit}
        >
          Submit Review
        </Button>
      </div>
    </div>
  );
};
export default TrainingsReview;
